module.exports = __webpack_public_path__ + "img/shape-1-mobile@2x.667c0bfe.png";